module.exports = __webpack_public_path__ + "static/media/ball_3_1.1a8c9cb8.mp3";